import { ENDPOINTS } from 'src/constants/endpoints'

import type { IDocumentsListResponseDTO } from 'src/app/home/pages/overview/domain/contracts/documents'
import { http } from 'src/interfaces/http'

export interface IGetDocumentsParams {
  page: number
  pageSize: number
}

export const getDocuments = async (
  params: IGetDocumentsParams,
): Promise<IDocumentsListResponseDTO> => {
  const { data } = await http.get<IDocumentsListResponseDTO>(
    ENDPOINTS.hanwha.documents,
    {
      params: {
        page: params.page,
        page_size: params.pageSize,
      },
    },
  )
  return data
}
